import type { ValueUpdater } from './seedanceTypes';

/** 支持 `setX(value)` 和 `setX((prev) => next)` 两种写法，方便从 useState 平滑迁移到 zustand。 */
export const resolveValueUpdater = <T>(current: T, next: ValueUpdater<T>) => {
  return typeof next === 'function' ? (next as (prev: T) => T)(current) : next;
};
